<script setup lang="ts">
import Header from './preview/Header.vue'
import DiscussionSlider from './preview/DiscussionSlider.vue'
import RewardsList from './preview/RewardsList.vue'

import type { LoyaltyReward } from '@/types/types'

defineProps<{ color: string; rewards: LoyaltyReward[] }>()
</script>

<template>
  <div class="bg-white text-left text-sm">
    <Header :color="color" />
    <DiscussionSlider :color="color" />
    <RewardsList :color="color" :rewards="rewards" />
  </div>
</template>
